import React, { useState } from 'react';
import { Typography, LinearProgress } from '@material-ui/core';
import { useTimeout } from '@fuse/hooks';
import PropTypes from 'prop-types';

function FuseLoading(props) {
  const { delay = false } = props;
  const [showLoading, setShowLoading] = useState(!delay);

  useTimeout(() => {
    setShowLoading(true);
  }, delay);

  if (!showLoading) {
    return null;
  }

  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <Typography className="text-20 mb-16" color="textSecondary">
        Loading...
      </Typography>
      <LinearProgress className="w-xs" color="secondary" />
    </div>
  );
}

FuseLoading.propTypes = {
  delay: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};


export default FuseLoading;
